import pipe from '../utils/pipe.js';
import VideoPlayer from './VideoPlayer.js';

const createSongStruct = function (songOpts) {
    return {
        state: songOpts.state,
        dom: {
            el: songOpts.el,
            videoPlayer: songOpts.el.querySelector('.video-player')
        },
        player: null
    };
};

const initVideoPlayer = function (songStruct) {
    songStruct.player = VideoPlayer({
        el: songStruct.dom.videoPlayer,
        songEl: songStruct.dom.el,
        state: songStruct.state
    });

    return songStruct;
};

const bindStateListeners = function (songStruct) {
    const {
        state
    } = songStruct;

    state.onChange(() => {
        updateUIState(songStruct);
    });

    return songStruct;
};

const bindDomEvents = function (songStruct) {
    const {
        dom
    } = songStruct;

    dom.el.onclick = function (evnt) { handleClick(songStruct, evnt); };
};

const handleClick = function (songStruct, evnt) {
    const { dom, player } = songStruct;
    const { target } = evnt;
    let isLink = false;
    let currentTarget = target;

    while (!isLink && currentTarget && currentTarget !== dom.el) {
        isLink = currentTarget.tagName === 'A';
        currentTarget = currentTarget.parentNode;
    }

    if (!isLink) {
        player.play();
    }
};

const updateUIState = function (songStruct) {
    const {
        dom,
        state
    } = songStruct;

    dom.el.setAttribute('data-player-state', state.key);
};

const Song = function (songOpts) {
    const songStruct = createSongStruct(songOpts);

    pipe(songStruct, [
        initVideoPlayer,
        bindStateListeners,
        bindDomEvents
    ]);

    return songStruct;
};

export default Song;



// WEBPACK FOOTER //
// ./assets/js/components/Song.js